import {defineMessages} from 'react-intl';

export const toggleMinimizeButtonMessages = defineMessages({
  open: {
    id: 'conversations_ui.widget.header.openButton.label',
    description:
      'Label used for the header button that takes the widget from a minimized state to an open state.',
    defaultMessage: 'Show',
  },
  minimize: {
    id: 'conversations_ui.widget.header.minimizeButton.label',
    description:
      'Label used for the header button that takes the widget from an open state to a minimized state.',
    defaultMessage: 'Hide',
  },
});
